export default "<div class=\"App\">\n  <header class=\"App-header\">\n      <app-nav></app-nav>\n  </header>\n</div>\n<router-outlet></router-outlet>\n"